const getFacetPickerConfig = (facetTree, activeSku)=>{
    const activeParentFacet = facetTree.find((parentFacet)=>parentFacet.skuCollection.includes(activeSku)
    );
    const childFacetsOfActiveParent = activeParentFacet === null || activeParentFacet === void 0 ? void 0 : activeParentFacet.childFacets;
    const activeChildFacet = childFacetsOfActiveParent === null || childFacetsOfActiveParent === void 0 ? void 0 : childFacetsOfActiveParent.find((sF)=>sF.sku === activeSku
    );
    /**
   * A user only needs to select a child facet if there is more than 1 option to choose from
   */ const childFacetRequiresUserSelection = !!((childFacetsOfActiveParent === null || childFacetsOfActiveParent === void 0 ? void 0 : childFacetsOfActiveParent.length) && childFacetsOfActiveParent.length > 1);
    /**
   * Only show the parent facet picker if there is more than 1 parent facet
   */ const showParentFacetPicker = facetTree.length > 1;
    /**
   * Currently, we only support "color" as the parent facet and "size" as the child facet
   * However, this should be made more generic in the future
   */ return {
        colorFacets: facetTree.filter((facet)=>facet.type === 'color'
        ),
        otherFacets: facetTree.filter((facet)=>facet.type === 'other'
        ),
        sizeFacets: childFacetsOfActiveParent,
        activeParentFacet,
        activeChildFacet,
        showParentFacetPicker,
        requiresUserSizeSelection: childFacetRequiresUserSelection
    };
};

export { getFacetPickerConfig };
//# sourceMappingURL=get-facet-picker-config.js.map
